module.exports = __webpack_public_path__ + "img/arrow.ebe23668.png";